// lib/tableStyles.ts — shared constants used by both Crew and Project tables
export const TABLE_STYLES = {
  wrapper: 'rounded-xl border border-border bg-card shadow-sm overflow-hidden',
  headerRow: 'border-b border-border bg-muted/30',
  headerCell:
    'h-10 px-4 text-[11px] font-semibold uppercase tracking-widest text-muted-foreground',
  bodyRow:
    'border-b border-border/50 transition-colors hover:bg-muted/20 data-[expanded=true]:bg-muted/30',
  cell: 'px-4 py-3 text-sm',
  // Pill button — used for Members AND Tickets
  pill: (active: boolean) =>
    active
      ? 'inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md text-xs font-medium border transition-colors bg-primary/10 text-primary border-primary/20 hover:bg-primary/20 cursor-pointer'
      : 'inline-flex items-center gap-1.5 h-7 px-2.5 rounded-md text-xs font-medium border bg-muted text-muted-foreground border-border cursor-default',
};
